<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin' }">
    <template #title>
      <span>{{
        translateTitleCase("lp.surpriseStock.joiner.list.title")
      }}</span>
    </template>

    <template #default>
      <custom-crud-list v-bind="listConfiguration" ref="crud-list">
        <template #cell-phoneNumber="{ item }">
          <span v-if="item.phoneNumber" class="force-ltr">
            {{ translateNumber(item.phoneNumber, "localPhone") }}
          </span>
          <span v-else> - </span>
        </template>

        <template #cell-redeemDateTime="{ item }">
          <span v-if="!item.redeemDateTime"> - </span>
          <span v-else>
            {{ translateDate(item.redeemDateTime, "dateWithTime") }}
          </span>
        </template>
        <template #cell-didRedeem="{ item }">
          <span v-if="item.didRedeem" class="c-success">
            <icon icon="check"></icon>
          </span>
          <span v-else class="c-error">
            <icon icon="x"></icon>
          </span>
        </template>

        <template #cell-gotSmsNotice="{ item }">
          <span v-if="item.gotSmsNotice" class="c-success">
            <icon icon="check"></icon>
          </span>
          <span v-else class="c-error">
            <icon icon="x"></icon>
          </span>
        </template>

        <template #cell-gotEmailNotice="{ item }">
          <span v-if="item.gotEmailNotice" class="c-success">
            <icon icon="check"></icon>
          </span>
          <span v-else class="c-error">
            <icon icon="x"></icon>
          </span>
        </template>
        <template #cell-SurpriseStock="{ item }">
          <span>{{ item.SurpriseStock ? item.SurpriseStock.name : "-" }}</span>
        </template>
      </custom-crud-list>

      <modal
        title="lp.surpriseStock.joiner.list.importModalTitle"
        :show="isShowingImportModal"
        @modal:closed="isShowingImportModal = false">
        <template #default>
          <div class="padding-s-bottom" v-if="importStep === 0">
            <p>{{ tu("lp.surpriseStock.joiner.list.importStep0Explain") }}</p>
            <form-input
              class="margin-l-top"
              label="lp.surpriseStock.joiner.list.importFileInputLabel"
              name="file"
              type="file"
              accept="text/csv"
              v-model="importFile"
              @change="importCsvChangeHandler"></form-input>
            <form-input
              class="margin-m-top"
              name="sendNotices"
              label="lp.surpriseStock.joiner.list.importSendNoticesInputLabel"
              type="onOffToggle"
              v-model="sendNotices"></form-input>
          </div>
          <div class="" v-if="importStep === 1">
            <p>
              {{
                tu("lp.surpriseStock.joiner.list.importStep1Explain", {
                  successfulCount: this.successfulImports.length,
                  failedCount: this.failedImports.length,
                })
              }}
            </p>
          </div>
        </template>
        <template #footer>
          <form-button
            v-if="importStep === 0"
            text="lp.surpriseStock.joiner.list.importStep0Cta"
            @click="runImportByState"></form-button>
          <form-button
            v-if="importStep === 1"
            text="lp.surpriseStock.joiner.list.importStep1Cta"
            @click="this.resetImportModal()"></form-button>
        </template>
      </modal>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";
import { computed } from "vue";
// todo:
// - import joiners with CSV
// - grant stock for new joiners
// - send SMS reminder via paycall
// - send email via inwise
// - ui for winning page
export default {
  props: {
    test: {
      type: String,
      default: "surpriseStockJoiner",
    },
  },
  components: { CustomCrudList },
  layout: "adminDashboard",
  middleware: {
    acl: "surpriseStockJoiner|list",
  },

  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "lp.surpriseStock.joiner.list.pageTitle",
  data: function () {
    return {
      importFile: false,
      sendNotices: true,
      importData: [],
      importStep: 0,
      failedImports: [],
      successfulImports: [],
      isShowingImportModal: false,
      listConfiguration: {
        subject: "surpriseStockJoiner",
        listSrc: "entity/surpriseStockJoiner",
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: true, //bool, default false
        enableMassActions: true,
        editRoute: (item) => {
          this.$router.push({
            name: "admin-entity-entityType-edit-entityId",
            params: { entityType: "surpriseStockJoiner", entityId: item.id },
          });
        },
        createRoute: {
          name: "admin-entity-entityType-create",
          params: { entityType: "surpriseStockJoiner" },
        },
        deleteRoutePrefix: "entity/",
        additionalListData: {
          simplified: false,
          translate: false,
        },
        fields: {
          // these are the table columns
          fullName: {
            itemKey: "fullName",
            label: "lp.surpriseStock.joiner.fields.fullName",
            filterable: true, // boolean, or object
            orderable: true,
            isPrimaryField: true,
            primaryField: true,
          },
          email: {
            itemKey: "email",
            label: "lp.surpriseStock.joiner.fields.email",
            filterable: true, // boolean, or object
            orderable: true,
            isPrimaryField: true,
            primaryField: true,
          },
          phoneNumber: {
            itemKey: "phoneNumber",
            label: "lp.surpriseStock.joiner.fields.phoneNumber",
            filterable: true, // boolean, or object
            orderable: true,
            isPrimaryField: true,
            primaryField: true,
          },
          uuid: {
            itemKey: "uuid",
            label: "lp.surpriseStock.joiner.fields.uuid",
            listable: false,
            orderable: true,
          },
          SurpriseStock: {
            itemKey: "SurpriseStock",
            label: "lp.surpriseStock.joiner.fields.stock",

            filterable: {
              name: "SurpriseStockId",
              type: "Select2",
              translateList: false,
              valueKey: "id",
              labelKey: "name",
              placeholder: "lp.surpriseStock.joiner.fields.stock",
              itemComponent: "iconItem",
              asyncListSource: "entity/SurpriseStock",
              asyncListLive: false,
              textFilterAsSaffronListFilter: true,
              asyncDataTextFilterParamName: "name",
              multiple: false,
              asyncListData: {
                simplifiedLabel: "name",
                simplified: true,
              },
            }, // boolean, or object
          },
          redeemDateTime: {
            itemKey: "redeemDateTime",
            label: "lp.surpriseStock.joiner.fields.redeemDateTime",
            orderable: true,
          },
          createdFrom: {
            itemKey: "createdFrom",
            label: "lp.surpriseStock.joiner.fields.createdFrom",
            listable: false,
            filterable: {
              name: "createdFrom",
              type: "datePicker",
              placeholder: "lp.surpriseStock.joiner.fields.createdFrom",
            },
            orderable: false,
          },
          createdBefore: {
            itemKey: "createdBefore",
            label: "lp.surpriseStock.joiner.fields.createdFrom",
            listable: false,
            filterable: {
              name: "createdBefore",
              type: "datePicker",
              placeholder: "lp.surpriseStock.joiner.fields.createdFrom",
            },
            orderable: false,
          },

          redeemedFrom: {
            itemKey: "redeemedFrom",
            label: "lp.surpriseStock.joiner.fields.redeemedFrom",
            listable: false,
            filterable: {
              name: "redeemedFrom",
              type: "datePicker",
              placeholder: "lp.surpriseStock.joiner.fields.redeemedFrom",
            },
            orderable: false,
          },
          redeemedBefore: {
            itemKey: "redeemedBefore",
            label: "lp.surpriseStock.joiner.fields.redeemedBefore",
            listable: false,
            filterable: {
              name: "redeemedBefore",
              type: "datePicker",
              placeholder: "lp.surpriseStock.joiner.fields.redeemedBefore",
            },
            orderable: false,
          },

          didRedeem: {
            itemKey: "didRedeem",
            label: "lp.surpriseStock.joiner.fields.didRedeem",
            orderable: true,
            filterable: {
              name: "didRedeem",
              type: "select2",
              placeholder: "lp.surpriseStock.joiner.fields.didRedeem",
              list: [
                { value: false, label: "core.no" },
                { value: true, label: "core.yes" },
              ],
            },
          },
          gotSmsNotice: {
            itemKey: "gotSmsNotice",
            label: "lp.surpriseStock.joiner.fields.gotSmsNotice",
            orderable: true,
            filterable: {
              name: "gotSmsNotice",
              type: "select2",
              placeholder: "lp.surpriseStock.joiner.fields.gotSmsNotice",
              list: [
                { value: false, label: "core.no" },
                { value: true, label: "core.yes" },
              ],
            },
          },
          gotEmailNotice: {
            itemKey: "gotEmailNotice",
            label: "lp.surpriseStock.joiner.fields.gotEmailNotice",
            orderable: true,
            filterable: {
              name: "gotEmailNotice",
              type: "select2",
              placeholder: "lp.surpriseStock.joiner.fields.gotEmailNotice",
              list: [
                { value: false, label: "core.no" },
                { value: true, label: "core.yes" },
              ],
            },
          },
        },
        actions: {
          show: false,
          edit: true,
          delete: true,

          custom: {
            copyRedeemLink: {
              text: "lp.surpriseStock.joiner.list.copyRedeemLinkShort",
              //tooltip
              tooltip: {
                content: "lp.surpriseStock.joiner.list.copyRedeemLink",
              },
              icon: "link",
              theme: "inverse",
              show: (item) => {
                return true;
              },
              handler: async ({ item }) => {
                let name = `surprise-stock-redeem-joinerUuid`;

                let params = {
                  joinerUuid: item?.uuid,
                };
                let query = {
                  //  isPreview: true,
                };

                let resolved = this.$router.resolve({ name, params, query });
                let relativePath = resolved.fullPath;
                let root = config.rootUrl;
                let link = root + relativePath;
                try {
                  navigator.clipboard.writeText(link);
                  this.$s.ui.notification(
                    "lp.surpriseStock.joiner.list.copyRedeemLinkSuccess",
                    "success"
                  );
                } catch (e) {
                  let alertText = this.t(
                    "lp.surpriseStock.joiner.list.copyRedeemLinkSuccessFailedClipBoard",
                    { link: link }
                  );

                  alert(alertText);
                }
              },
            },
            sendSmsNotice: {
              //tooltip
              text: "lp.surpriseStock.joiner.list.sendSmsNotice",
              tooltip: {
                content: "lp.surpriseStock.joiner.list.sendSmsNotice",
              },
              icon: "phone-ringing",
              theme: "alt",
              show: (item) => {
                return item.phoneNumber && item.phoneNumber !== "";
              },
              handler: async ({ item }) => {
                let url = `surprise-stock/joiner/notice/sms/${item.id}`;

                let result;

                try {
                  this.$s.ui.globalSpinner.show();
                  result = await this.asyncOps.post(url, {});
                } catch (e) {}
                this.$s.ui.globalSpinner.hide();
                if (!result || result.hasError) {
                  this.$s.ui.notification(
                    "lp.surpriseStock.joiner.list.sendSmsNoticeError",
                    "error"
                  );
                  return;
                }
                this.$s.ui.globalSpinner.show();
                try {
                  await this.$refs["crud-list"].reloadItems();
                } catch (e) {}

                this.$s.ui.globalSpinner.hide();
                this.$s.ui.notification(
                  "lp.surpriseStock.joiner.list.sendSmsNoticeSuccess",
                  "success"
                );
              },
            },
            sendEmailNotice: {
              //tooltip
              text: "lp.surpriseStock.joiner.list.sendEmailNotice",
              tooltip: {
                content: "lp.surpriseStock.joiner.list.sendEmailNotice",
              },
              icon: "email",
              theme: "alt",
              show: (item) => {
                return item.email && item.email !== "";
              },
              handler: async ({ item }) => {
                let url = `surprise-stock/joiner/notice/email/${item.id}`;

                let result;

                try {
                  this.$s.ui.globalSpinner.show();
                  result = await this.asyncOps.post(url, {});
                } catch (e) {}
                this.$s.ui.globalSpinner.hide();
                if (!result || result.hasError) {
                  this.$s.ui.notification(
                    "lp.surpriseStock.joiner.list.sendEmailNoticeError",
                    "error"
                  );
                  return;
                }
                this.$s.ui.globalSpinner.show();
                try {
                  await this.$refs["crud-list"].reloadItems();
                } catch (e) {}

                this.$s.ui.globalSpinner.hide();
                this.$s.ui.notification(
                  "lp.surpriseStock.joiner.list.sendEmailNoticeSuccess",
                  "success"
                );
              },
            },
          },
        },
        massActions: {
          delete: true,
          import: {
            defaultFields: ["fullName", "email", "phoneNumber"],
            additionalFields: {
              sendNotices: {
                name: "sendNotices",
                label:
                  "lp.surpriseStock.joiner.list.importSendNoticesInputLabel",
                type: "onOffToggle",
              },
            },
            defaultAdditionalData: {
              sendNotices: false,
            },
            itemParser: (item) => {
              item.phoneNumber = item.phoneNumber
                .replaceAll("-", "")
                .replaceAll(" ", "")
                .replaceAll(")", "")
                .replaceAll("(", "");
              if (
                typeof item.phoneNumber === "string" &&
                item.phoneNumber !== "" &&
                !item.phoneNumber.startsWith("0")
              ) {
                item.phoneNumber = "0" + item.phoneNumber;
              }

              return item;
            },
          },
          /*
          custom: {
            import: {
              text: "lp.surpriseStock.joiner.list.importFromCsv",
              tooltip: "lp.surpriseStock.joiner.list.importFromCsv",
              icon: "user-plus",
              theme: "success",
              alwaysShow: true,
              handler: ({ items }) => {
                this.resetImportModal();
                this.isShowingImportModal = true;
              },
            },
          },
          */
        },
      },
      asyncData: {},
    };
  },
  methods: {
    parseCSVFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
          const text = event.target.result;
          const [headerLine, ...lines] = text.split("\n").filter(Boolean);
          const headers = headerLine.split(",").map((h) => h.trim());

          const data = lines.map((line) => {
            const values = line.split(",").map((v) => v.trim());
            return headers.reduce((obj, header, index) => {
              obj[header] = values[index];
              return obj;
            }, {});
          });

          resolve(data);
        };

        reader.onerror = reject;
        reader.readAsText(file);
      });
    },

    resetImportModal() {
      this.importData = [];
      this.importStep = 0;
      this.failedImports = [];
      this.successfulImports = [];
      this.isShowingImportModal = false;
    },
    importCsvChangeHandler(e) {
      //console.log(e);
    },
    async runImportByState() {
      let data = await this.parseCSVFile(this.importFile[0]);
      let current = 0;
      let max = data.length;

      let confirm;
      try {
        confirm = await this.$s.ui.modal.confirm(
          "lp.surpriseStock.joiner.list.massImportConfirmContent",
          undefined,
          {
            contentParams: { count: max },
          }
        );
      } catch (e) {
        this.isShowingImportModal = false;
        this.$s.ui.notification("lp.surpriseStock.joiner.list.uploadCanceled");
        return false;
      }
      this.$s.ui.globalSpinner.show({
        active: true,
        text: "lp.surpriseStock.joiner.list.uploadingData",
        params: { current, max },
      });
      let currentUserId = this.sg("user.profile")?.id;
      for (const item of data) {
        let uploadResult = false;

        if (
          item.phoneNumber &&
          item.phoneNumber != "" &&
          typeof item.phoneNumber === "string" &&
          !item.phoneNumber.startsWith(0)
        ) {
          item.phoneNumber = "0" + item.phoneNumber;
        }

        if (item.phoneNumber) {
          item.phoneNumber = item.phoneNumber
            .replaceAll("-", "")
            .replaceAll(" ", "");
        }

        try {
          this.$s.ui.globalSpinner.show({
            active: true,
            text: "lp.surpriseStock.joiner.list.uploadingData",
            params: { current, max },
          });
          uploadResult = await this.asyncOps.post(
            "entity/surpriseStockJoiner",
            {
              entityData: {
                ...item,
                state: 1,
                OwnerId: currentUserId,
              },
              createRequestData: {
                sendNotices: this.sendNotices,
              },
            }
          );
          if (uploadResult.hasError) {
            this.failedImports.push(item);
          } else {
            this.successfulImports.push(item);
          }
        } catch (e) {
          console.log("err");
          console.log(e);
          this.failedImports.push(item);
        }

        current++;
      }
      this.$s.ui.globalSpinner.hide();
      this.importStep = 1;
      this.$refs["crud-list"].reloadItems();
    },
  },
};
</script>

<style scoped lang="scss"></style>
